export default __webpack_public_path__ + "19c900751ecc3aa50bbf658ee63dcf19.png";